import { EventNames } from '../../types/misc.types'
import { openVideoPlayer, trackEvent } from '../../utils/appBridge'
import type { EliteEventExtras } from '../../utils/eliteEventExtras'
import { useEliteBuyCtaExtras } from './EliteBuyCtaExtrasContext'

const ASSETS = {
  portrait: '/images/elite/trust-markers/video-portrait.png',
  pattern: '/images/elite/trust-markers/video-card-pattern.svg',
  playCircle: '/images/elite/trust-markers/video-play-circle.svg'
} as const

const ELITE_ABOUT_VIDEO = {
  courseId: 'COURSEde919cce87264b1480e91195a96442b0',
  videoId: '13b10ea0fb854453bd20d33894913418',
  moduleId: 'MDb7714f7a516c41ffb1f9f3fa5c9316b3'
} as const

export const VIDEO_TRUST_MARKER_PORTRAIT = ASSETS.portrait

export type EliteAboutVideoSource = 'trust_marker' | 'fab'

export function openEliteAboutVideo(source: EliteAboutVideoSource, extras: EliteEventExtras = {}) {
  const { eventId, buttonLabel } = getEliteAboutVideoEventMeta(source)
  trackEvent({
    eventName: EventNames.ButtonTap,
    payload: {
      ...extras,
      screenType: getEliteAboutVideoScreenType(),
      buttonLabel,
      eventId
    }
  })
  openVideoPlayer(
    `https://pumobileweb.uni.club/power-academy/video-player?videoId=${ELITE_ABOUT_VIDEO.videoId}&moduleId=${ELITE_ABOUT_VIDEO.moduleId}&courseId=${ELITE_ABOUT_VIDEO.courseId}&prevStatusBarColor=20A5DE`
  )
}

export default function VideoTrustMarker() {
  const buyCtaExtras = useEliteBuyCtaExtras()
  return (
    // z-0 contains overflow/compositor layers so this card cannot paint over fixed CTAs
    <div
      onClick={() => openEliteAboutVideo('trust_marker', buyCtaExtras)}
      className='relative z-0 w-full cursor-pointer overflow-hidden rounded-[20px] border-2 border-white bg-gradient-to-b from-[#ffebcd] to-[#fbf1e4]'
    >
      <img
        alt=''
        src={ASSETS.pattern}
        width={222}
        height={222}
        className='pointer-events-none absolute left-[-19px] top-[-13px] z-0 max-w-none'
      />
      <div className='relative flex items-center gap-3 py-2.5 pl-5 pr-2.5'>
        <div className='flex min-w-0 flex-1 flex-col gap-[17px]'>
          <p className='text-base font-medium leading-[1.4] text-[#CC5C2D]'>Still confused?</p>
          <p className='text-lg font-medium leading-[1.3] text-[#3D3D3D]'>
            Learn how Elite helps you invest better
          </p>
        </div>
        <div className='relative h-[198px] w-[163px] shrink-0'>
          <img
            alt=''
            src={ASSETS.portrait}
            className='h-full w-full'
          />
          <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
            <img alt='' src={ASSETS.playCircle} width={39.5} height={39.5} className='max-w-none' />
          </div>
        </div>
      </div>
    </div>
  )
}

export function getEliteAboutVideoEventMeta(source: EliteAboutVideoSource) {
  if (source === 'trust_marker') {
    return {
      eventId: 'elite_about_video_trust_marker',
      buttonLabel: 'Open Elite About Video'
    }
  }
  return {
    eventId: 'elite_about_video_fab',
    buttonLabel: 'About Elite FAB'
  }
}

export function getEliteAboutVideoScreenType() {
  const path = window?.location?.pathname ?? ''
  if (path.includes('new-elite-family-dashboard')) return 'NewElite_Family_Dashboard'
  if (path.includes('new-elite-family-landing')) return 'NewElite_Family_Landing'
  if (path.includes('new-elite-dashboard')) return 'NewElite_Dashboard'
  if (path.includes('new-elite-landing')) return 'NewElite_Landing'
  if (path.includes('elite-plans-family-member')) return 'Elite_Plans_Family_Member'
  if (path.includes('elite-plans-family-landing')) return 'Elite_Plans_Family_Landing'
  if (path.includes('elite-prime-family-dashboard')) return 'Elite_Prime_Family_Dashboard'
  if (path.includes('elite-prime-family-landing')) return 'Elite_Prime_Family_Landing'
  if (path.includes('elite-plans')) return 'Elite_Plans_Landing'
  return 'MF_Elite_Landing'
}
